import * as React from 'react';
import {ITextProps} from './ITextProps';
import {Base} from './Base';

export const T1 = (props: ITextProps) => {
  return <Base typoClass="typoT1" {...props} />;
};
